import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { IEntity } from '@interfaces/entity';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Manufacturer } from '@models/manufacturer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManufacturersService } from '@services/entity/manufacturer.services';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-manufacturer-dialog-content',
  templateUrl: './create-manufacturer-dialog-content.component.html',
  styleUrls: ['./create-manufacturer-dialog-content.component.scss']
})
export class CreateManufacturerDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateManufacturerDialogContentComponent';

  public customerId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public manufacturerService: ManufacturersService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  createForm() {
    this.formService.validators = {
      name: [Validators.required],
    }

    this.formService.form = new FormGroup({
      name: new FormControl('', this.formService.validators['name']),
    });
  }

  onSubmit(formValue) {
    var entity = new Manufacturer(formValue);
      this.manufacturerService.createEntity(entity).subscribe(data => {
        this.activeModal.close();
        this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Hersteller erfolgreich gespeichert.`);
        // this.openSuccessDialog();
      }, error => {
        this.toastService.error($localize`:@@CreateDialogSaveSuccessHeader:Hersteller konnte nicht gespeichert werden.`);

      });
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@CreateDialogSaveSuccessHeader:Hersteller wurde gespeichert!`,
      text: $localize`:@@CreateDialogSaveSuccessText:Der neue Hersteller wurde angelegt.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.activeModal.close();
    });
  }
}
